import _ from 'lodash'

import { vsName as CommonMachinesServerName } from '../../../../Server/index'
import fieldHelpers from '../../../../../../ui-formly/fieldHelpers/index'
function formly() {
  var fields = [

    fieldHelpers.columnLayout(
      [
        {
          key: "MealLogReasonId",
          name: "MealLogReasonId",
          type: "selectAsync",
          templateOptions: {
            label: "Reason",
            required: true,
            query: [CommonMachinesServerName, function (CommonMachinesServer) {
              return function (search) {
                return CommonMachinesServer.mealLogReasonsQuery({
                  NameContains: search,
                  Disabled: false,
                  Skip: 0,
                  Take: 25,
                  OrderBy: 'Order'
                })
              }
            }],
            getDefaultItem: function (model) {
              return {
                Id: model.MealLogReasonId,
                Name: model.MealLogReasonName
              }
            },
            onChange: function ($viewValue, model, scope) {
              const selectedReason = _.find(model.templateOptions.options, { Id: scope.model.MealLogReasonId });
              
              scope.model.MealLogReason = selectedReason || null;
            }
          }
        },
        fieldHelpers.simpleDateTimeField({ key: 'OpenedDate', label: 'Opened', required: true }),
        fieldHelpers.simpleDateTimeField({ key: 'ClosedDate', label: 'Closed', required: true }),
      ], 3),
    fieldHelpers.columnLayout(
      [
        {
          key: "Notes",
          name: "Notes",
          type: "textarea",
          templateOptions: {
            label: "Notes",
            required: false,
            rows: 5,
          },
          expressionProperties: {
            'templateOptions.required': ($viewValue, $modelValue, scope) => {
              const reason = (scope.model || {}).MealLogReason;
              return reason.NotesRequired || false;
            },
          },
        }
      ], 1)
  ]

  return _.flatten(fields, false)
}

mealLogReasonsFieldController.$inject = ['$scope', CommonMachinesServerName]
function mealLogReasonsFieldController($scope, CommonMachineServer) {
  $scope.query = query

  function query(search) {
    return CommonMachineServer.mealLogReasonsQuery({
      NameContains: search,
      Disabled: false,
      Skip: 0,
      Take: 25,
      OrderBy: 'Order'
    })
      .then(function (result) {
        $scope.options.templateOptions.options = result.Results
      })
  }
}

export default formly